import type {SearchType} from '../rules/constants';
import type {SearchRules} from '../rules';
import {getRuleAtIndex} from './getRuleAtIndex';

/**
 * Get a rule by type, will return first occurence of the type
 * @param rules Search rules
 * @param type Rule type
 * @returns Rule
 */
export const getSearchRuleByType = <
	T extends SearchRules = SearchRules,
	K extends SearchType = SearchType,
>(
	rules: T,
	type: K,
) => {
	const index = rules.elementTypes.findIndex((ruleType) => ruleType === type);
	return index !== -1 ? getRuleAtIndex<T>(rules, index) : undefined;
};
